import service from '@/service'

const state = {
  background: ''
}

const mutations = {
  setBackground (state, { photo }) {
    state.background = photo
  }
}

const actions = {
  fetchBackground ({ commit }) {
    service.manifest.background()
      .then((res = {}) => {
        commit('setBackground', res.Photo)
      })
  }
}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/manifest.js